<template>
  <div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="cPage"
      :page-size="pageSize"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    props: {
      currentPage: {
        default: 1
      },
      total: {
        default: 0
      },
      pageSize: {
        default: 20
      }
    },
    watch: {
      currentPage () {
        this.cPage = this.currentPage
      }
    },
    data () {
      return {
        cPage: this.currentPage
      }
    },
    created () {
      // this.$emit('pageChanged', {limit: this.pageSize, offset: (this.currentPage - 1) * this.pageSize})
    },
    components: {},
    methods: {
      handleSizeChange (val) {
        this.cPage = val
        this.$emit('pageChanged', {currentPage: this.cPage, limit: val, offset: (this.cPage - 1) * this.pageSize})
      },
      handleCurrentChange (val) {
        this.cPage = val
        this.$emit('pageChanged', {currentPage: this.cPage, limit: this.pageSize, offset: (this.cPage - 1) * this.pageSize})
      }
    },
    computed: {
      ...mapState({})
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Page.vue?a13a9502